<template>
    <v-dialog v-model="isActive" width="500" @click:outside="cancelHandle">
        <div class="meeting">
            <div class="meeting__head">
                <h3 class="meeting__title">
                    {{ textContent['meeting-edit'] }}
                </h3>
            </div>
            <div class="meeting__body">
                <div class="meeting__input-wrapper">
                    <v-text-field
                        v-model="fields['date']"
                        dense
                        outlined
                        type="date"
                        name="date"
                        :label="textContent['date']"
                        :error-messages="errors['date']"
                        @input="errors['date'] = ''"
                    ></v-text-field>
                </div>
                <div class="meeting__input-wrapper">
                    <v-autocomplete
                        v-model="fields['time']"
                        outlined
                        :items="time"
                        :label="textContent['time']"
                        dense
                        :error-messages="errors['time']"
                        @input="errors['time'] = ''"
                    >
                    </v-autocomplete>
                </div>
                <div
                    v-if="checkIsPickUpNew() || checkIsRepair()"
                    class="meeting__input-wrapper"
                >
                    <v-autocomplete
                        v-model="fields['manager_id']"
                        outlined
                        :items="meetingManagers"
                        item-text="nickName"
                        item-value="id"
                        :label="$t(`pages.calendar.chooseManager.designer`)"
                        dense
                        :error-messages="errors['manager_id']"
                        @input="errors['manager_id'] = ''"
                    >
                    </v-autocomplete>
                </div>
                <div v-if="isnUsaManager" class="meeting__input-wrapper">
                    <v-autocomplete
                        v-model="fields['calendar']"
                        outlined
                        :items="types"
                        :label="textContent['calendar']"
                        dense
                        :error-messages="errors['calendar']"
                        @input="errors['calendar'] = ''"
                        @change="dropTimeOutsideSlots"
                    >
                    </v-autocomplete>
                </div>
                <div class="meeting__input-wrapper">
                    <v-text-field
                        v-model="fields['subject']"
                        dense
                        outlined
                        type="text"
                        name="subject"
                        :label="textContent['subject']"
                        :error-messages="errors['subject']"
                        @input="errors['subject'] = ''"
                    ></v-text-field>
                </div>
                <div
                    v-if="
                        isnUsaManager && (checkIsPickUpNew() || checkIsRepair())
                    "
                    class="meeting__checkbox"
                >
                    <v-checkbox
                        :input-value="isRepair"
                        :label="textContent['repairs']"
                        @change="onRepairCheckboxChange"
                    ></v-checkbox>
                </div>
            </div>
            <div class="meeting__foot">
                <div class="meeting__foot">
                    <v-btn color="#55595c" dark small @click="cancelHandle">
                        {{ textContent['close'] }}
                    </v-btn>
                    <v-btn color="#967adc" dark small @click="updateHandle">
                        {{ textContent['update'] }}
                    </v-btn>
                </div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import { getRange } from '@/helpers/rangeFromDate'
import { getDateYyyyMmDd, getTimeHhMm } from '@/helpers/getDateInFormat'
import { mapActions } from 'vuex'
import { actionTypes } from '@/store/modules/calendar'
import { actionTypes as actionTypesModalNotifications } from '@/store/modules/modal-notifications'
import languageMixin from '@/mixins/language.mixin'
import { actionTypes as actionTypesOrders } from '@/store/modules/orders'
import { meetingListActionTypes } from '@/store/modules/meeting-list/types'
import { getMeetingTimeSlots } from '@/helpers/meeting-time-slots.utils'

export default {
    name: 'CalendarModalUpdate',
    mixins: [languageMixin],
    props: {
        meeting: {
            type: Object,
            default: () => ({}),
        },
        isActiveData: {
            type: Boolean,
            default: false,
        },
        typeOfMeetings: {
            type: String,
            default: 'orders',
        },
        meetingManagers: {
            type: Array,
            default: () => [],
        },
    },
    emits: ['close-handle'],
    data() {
        return {
            oldRange: null,
            fields: {
                subject: '',
                date: '',
                time: '',
                calendar: '',
                client: '',
                client_id: '',
                wig_id: '',
                manager_id: null,
                visible: true,
                isBusy: false,
            },
            errors: {},
            isRepair: false,
        }
    },
    computed: {
        types: function () {
            return [
                { text: this.textContent['orders'], value: 'ORDERS' },
                {
                    text: this.textContent['pick-up-new'],
                    value: 'PICK_UP_NEW',
                },
                { text: this.textContent['repairs'], value: 'REPAIRS' },
                {
                    text: this.textContent['pick-up-repairs'],
                    value: 'PICK_UP_REPAIRS',
                },
                { text: this.textContent['us-agent'], value: 'US_AGENT' },
            ]
        },
        textContent: function () {
            return this.getTextForSelected(this.lang, 'CalendarModalAdd') || ''
        },
        isActive: {
            get: function () {
                return this.isActiveData
            },
            set: function () {
                this.cancelHandle()
            },
        },
        time: function () {
            return getMeetingTimeSlots(this.fields.calendar)
        },
        completeDate: function () {
            return `${this.fields.date} ${this.fields.time}`
        },
        isnUsaManager: function () {
            return !this.getAllowed(['usa_manager'])
        },
    },
    watch: {
        'fields.calendar': function (newVal) {
            if (newVal === 'REPAIRS') {
                this.isRepair = true
                return
            }

            if (this.isRepair) {
                this.isRepair = false
            }
        },
        isActive: function () {
            if (!this.isActive) return
            let type = this.meeting?.calendar || this.meeting?.calendarType

            switch (type.toLowerCase()) {
                case 'pick-up new wigs':
                    this.fields.calendar = 'PICK_UP_NEW'
                    break
                case 'repairs':
                    this.fields.calendar = 'REPAIRS'
                    break
                case 'pick-up repairs':
                    this.fields.calendar = 'PICK_UP_REPAIRS'
                    break
                case 'us_agent':
                    this.fields.calendar = 'US_AGENT'
                    break
                default:
                    this.fields.calendar = 'ORDERS'
            }

            this.fields.client = this.meeting.client
            this.fields.wig_id = this.meeting.wigId
            this.fields.client_id = this.meeting.client_id
            this.fields.manager_id = this.meeting.meetingManager
                ? this.meeting.meetingManager.id
                : null
            this.fields.subject = this.meeting.subject
            this.fields.date = getDateYyyyMmDd(this.meeting.startAt)

            this.fields.time = getTimeHhMm(this.meeting.startAt)
            this.oldRange = getRange(this.meeting.start_at)

            this.isRepair = this.meeting.calendar.toLowerCase() === 'repairs'
        },
    },
    methods: {
        ...mapActions('meetingList', {
            fetchMeetingList: meetingListActionTypes.FETCH_MEETINGS,
        }),
        ...mapActions('calendar', { onUpdate: actionTypes.updateOne }),
        ...mapActions('modalNotifications', {
            success: actionTypesModalNotifications.success,
        }),
        ...mapActions('orders', {
            updateCompleteDate: actionTypesOrders.updateCompleteDate,
        }),
        cancelHandle: function () {
            this.$emit('close-handle')
        },
        validateFields() {
            let isValid = true

            this.$set(this.errors, 'date', '')
            this.$set(this.errors, 'time', '')
            this.$set(this.errors, 'calendar', '')

            if (!this.fields['date']) {
                this.errors['date'] = this.$t(
                    'pages.calendar.validation.requiredDate'
                )
                isValid = false
            }

            if (!this.fields['time']) {
                this.errors['time'] = this.$t(
                    'pages.calendar.validation.requiredTime'
                )
                isValid = false
            }

            if (!this.fields['calendar']) {
                this.errors['calendar'] = this.$t(
                    'pages.calendar.validation.requiredCalendar'
                )
                isValid = false
            }

            return isValid
        },
        updateHandle: function () {
            if (!this.validateFields()) return

            if (this.isBusy) return

            const isPickUpNewOrRepair =
                this.fields.calendar === 'PICK_UP_NEW' ||
                this.fields.calendar === 'REPAIRS'

            if (isPickUpNewOrRepair) {
                this.fields.calendar = this.isRepair ? 'REPAIRS' : 'PICK_UP_NEW'
            }

            const data = this.fields
            const id = this.meeting.id
            const oldRange = this.oldRange
            const oldType = this.typeOfMeetings
            const oldData = this.meeting

            this.isBusy = true
            this.onUpdate({ data, id, oldRange, oldType, oldData })
                .then(() => {
                    this.success('Meeting has bee updated')
                    if (data.calendar === 'PICK_UP_NEW') {

                        this.updateCompleteDate({
                            id: this.fields.wig_id,
                            completeData: this.completeDate,
                            shouldReload: this.$route.name === 'wigCard',
                        })
                    }
                    this.isBusy = false
                    this.cancelHandle()
                    this.fetchMeetingList()
                })
                .catch((er) => {
                    this.isBusy = false
                    this.errors = er
                })
        },
        dropTimeOutsideSlots: function () {
            if (this.fields.time && !this.time.includes(this.fields.time)) {
                this.fields.time = ''
            }
        },
        checkIsPickUpNew: function () {
            return this.fields.calendar === 'PICK_UP_NEW'
        },
        checkIsRepair: function () {
            return this.fields.calendar === 'REPAIRS'
        },
        onRepairCheckboxChange: function (val) {
            this.isRepair = val

            if (val) {
                this.fields.calendar = 'REPAIRS'
                return
            }

            if (this.fields.calendar === 'REPAIRS') {
                this.fields.calendar = 'PICK_UP_NEW'
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.meeting {
    background: $color-primary-light;

    &__head {
        padding: 10px;
        border-bottom: 1px solid #eceeef;
    }

    &__title {
        font-weight: 500;
    }

    &__body {
        padding: 0 10px;
    }

    &__foot {
        padding: 0 5px 5px;
        display: flex;
        width: 100%;
        justify-content: space-between;
    }

    &__checkbox {
        padding: 0;
        margin: 0;

        ::v-deep .v-input__control {
            margin: 0;
            padding: 0;
        }

        ::v-deep .v-label {
            margin: 0;
            padding: 0;
        }

        ::v-deep .v-input {
            margin: 0;
            padding: 0;
        }
    }
}
</style>
